import React, {Component} from 'react';
import {connect} from 'react-redux';
import Modal from '../../components/Modal';
import FileUpload from '../../pages/Comun/FileUpload';


class SeleccionarAdjunto extends Component {
    constructor(props, context) {
        super(props, context);
        this.handleShow = this.handleShow.bind(this);
        this.handleHide = this.handleHide.bind(this);
        this.state = {};
    }

    handleShow() {
        this.setState({show: true});
    }

    handleHide() {
        this.setState({show: false});
    }


    render() {
        return (
            <div>
                <Modal idModal='seleccionar-situacion' modalSize='modal-dialog modal-lg' title='Seleccionar Adjunto'
                       closeModal={this.props.closeModal}
                       isOpen
                >
                    <div className='steps-container fdvNew-slides'>
                        <div className='row'>
                            <div className='col-md-6 mb-3 mt-2'>
                                <div className='form-group'>
                                    <label className='labelInfo'>Tipo de Plantilla
                                    </label>
                                    <select className='form-control'  onChange={this.props.changeTipoPlantilla}>
                                        <option value='1'>Plantilla Título</option>
                                        <option value='2'>Plantilla Placa</option>
                                        <option value='3'>Plantilla Situaciones</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <FileUpload onDrop={this.props.onDrop.bind(this)} accept='.xlsx,.xls'/>
                        </div>
                        <div className='modal-actions'>
                        </div>

                    </div>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}


SeleccionarAdjunto.defaultProps = {};
export default connect(mapStateToProps,
    {})(SeleccionarAdjunto);



// WEBPACK FOOTER //
// ./src/pages/Inmatriculacion/SeleccionarAdjunto.js